import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from '../../../contexts/AuthContext'
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function GastosTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_GASTOS_TIENDAS = import.meta.env.VITE_URL_GASTOS_TIENDAS;
  const URL_CAJAS = import.meta.env.VITE_URL_CAJAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [fecha, setFecha] = useState(hoy);
  const [subtotal, setSubtotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState("NA");
  const [concepto, setConcepto] = useState("");
  const [cajas, setCajas] = useState([]);
  const [caja, setCaja] = useState(user.cajaId || "");

  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const submittingRef = useRef(false);

  useEffect(() => {
    if (!user?.areas) return;
    const areaParam = Array.isArray(user.areas) ? user.areas[0] : user.areas;
    axios.get(`${URL_CAJAS}Area/${areaParam}`, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then((res) => {
      setCajas(res.data.filter((c) => c.is_active === "Si"));
    }).catch((err) => console.log(err));
  }, [user?.areas]);

  // Preselecciona la caja de la sesion (login) cuando el user este listo.
  useEffect(() => {
    if (user?.cajaId) setCaja((prev) => prev || user.cajaId);
  }, [user?.cajaId]);


  const calcula = (e) => {
    setSubtotal(e);
    setTotal(parseFloat(e) + parseFloat(iva))
  };

  const calculaIVA = (e) => {
    setIva(e);
    setTotal(parseFloat(subtotal) + parseFloat(e))
  };

  const saveGasto = (event) => {
    event.preventDefault();
    if (cajas.length > 0 && !caja && !user?.cajaId) {
      Swal.fire({
        icon: "warning",
        title: "Falta la caja",
        text: "Selecciona la caja en la que se hizo el gasto.",
      });
      return;
    }
    if (submittingRef.current) return;
    submittingRef.current = true;
    setValidaBoton(false)
          axios.post(
            URL_GASTOS_TIENDAS,
            {
              fecha,
              subtotal,
              iva,
              total,
              descripcion,
              concepto,
              areas: user.areas,
              caja: caja || user.cajaId || undefined
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
        .then(() => {
          axios
          .post(
            URL_LOGS,
            {
              tipo:'Crear Gasto Tienda',
              detalle: `Fecha: ${fecha} / Concepto: ${concepto} / Total: ${total} `,
              user: user.id
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        )
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
          submittingRef.current = false;
          setValidaBoton(true)
        });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.gastosTiendas  ?(
      <div className="container">
        <div className="card container col-sm-8">
          <h3 align="center">Nuevo Gasto</h3>
          <Form onSubmit={saveGasto}>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row> 
              <Col md={6}>
                <Label>Concepto</Label>
                <Input
                  type="select"
                  placeholder="Concepto"
                  value={concepto}
                  required
                  onChange={(e) => {
                    setConcepto(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Agua">Agua</option>
                  <option value="Camionetas">Camionetas</option>
                  <option value="Telefono">Telefono</option>
                  <option value="Policia">Policia</option>
                  <option value="Limpieza">Limpieza</option>
                  <option value="Papeleria">Papeleria</option>
                  <option value="Varios">Varios</option>
                </Input>
              </Col>
                <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                              Descripcion
                            </Label>
                            <Input
                              type="text"
                              placeholder="Descripcion"
                              value={descripcion}
                              required
                              onChange={(e) => {
                                setDescripcion(e.target.value);
                              }}
                            />
                </Col>
              </Row>
            

            {cajas.length > 0 && (
              <Row>
                <Col md={6}>
                  <Label>Caja</Label>
                  <Input
                    type="select"
                    value={caja}
                    required
                    onChange={(e) => setCaja(e.target.value)}
                  >
                    <option value="">Selecciona Caja</option>
                    {cajas.map((c) => (
                      <option key={c._id} value={c._id}>{c.nombre}</option>
                    ))}
                  </Input>
                </Col>
              </Row>
            )}

            <Row>
               <Col sm={4}>
               <Label for="exampleEmail" className="mr-sm-2">
                Subtotal
              </Label>
              <Input
                type="number"
min="0"
step="any"
                placeholder="Subtotal"
                value={subtotal}
                required
                onChange={(e)=>calcula(e.target.value)}
              />
               </Col>
               <Col sm={4}>
               <Label for="exampleEmail" className="mr-sm-2">
                IVA 
              </Label>
              <Input
                type="number"
min="0"
step="any"
                placeholder="IVA"
                value={iva}
                required
                onChange={(e)=>calculaIVA(e.target.value)}
              />
               </Col>
               <Col sm={4}>
               <Label for="exampleEmail" className="mr-sm-2">
                Total
              </Label>
              <Input
                type="number"
min="0"
step="any"
                placeholder={total}
                disabled
              />
               </Col>
             </Row>
              
            </FormGroup>
            <br />
            <Col>
              <Row>
              {validaBoton ? (
        <Button type="submit" className="btn btn-success">
        Guardar
      </Button>
      ):(
      <Button type="submit" className="btn btn-success" disabled>
        Guardar
      </Button>)}
                <Button
                  href="/GastosTiendas"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Row>
            </Col>
          </Form>
        </div>
      </div>
      ): undefined } 
    </>
  );
}

export default GastosTiendasCreate;
